import React, { memo } from 'react';
import PropTypes from 'prop-types';

const NeumorphicDivider = ({ widthPercentage = 100 }) => {
  // Original viewBox dimensions
  const viewBoxWidth = 472;
  const centerX = viewBoxWidth / 2; // Center point of the SVG
  
  // Calculate the line width based on percentage
  const maxLineWidth = 452.5;
  const lineWidth = maxLineWidth * (widthPercentage / 100);
  
  // Calculate start and end points to center the line
  const startX = centerX - (lineWidth / 2);
  const endX = centerX + (lineWidth / 2);
  
  return (
    <svg viewBox="0 0 472 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d_1_1731)">
        <path d={`M${startX} 10H${endX}`} stroke="#9404C3" strokeWidth="3" strokeLinecap="round"/>
      </g>
      <g filter="url(#filter1_d_1_1731)">
        <path d={`M${startX} 10H${endX}`} stroke="url(#paint0_linear_1_1731)" strokeWidth="1.5" strokeLinecap="round" shapeRendering="crispEdges"/>
      </g>
      <defs>
        <filter id="filter0_d_1_1731" x="0.5" y="0.5" width="471.5" height="19" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feOffset/>
          <feGaussianBlur stdDeviation="4"/>
          <feComposite in2="hardAlpha" operator="out"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0.580392 0 0 0 0 0.0156863 0 0 0 0 0.764706 0 0 0 1 0"/>
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_1731"/>
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_1731" result="shape"/>
        </filter>
        <filter id="filter1_d_1_1731" x="1.25" y="1.25" width="470" height="17.5" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feOffset/>
          <feGaussianBlur stdDeviation="4"/>
          <feComposite in2="hardAlpha" operator="out"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0.580392 0 0 0 0 0.0156863 0 0 0 0 0.764706 0 0 0 1 0"/>
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_1731"/>
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_1731" result="shape"/>
        </filter>
        <linearGradient id="paint0_linear_1_1731" x1="10" y1="10.5" x2="462.5" y2="10.5" gradientUnits="userSpaceOnUse">
          <stop stopColor="white" stopOpacity="0"/>
          <stop offset="0.48" stopColor="white"/>
          <stop offset="0.995" stopColor="white" stopOpacity="0"/>
        </linearGradient>
      </defs>
    </svg>
  );
};

const arePropsEqual = (prevProps, nextProps) => {
  return prevProps.widthPercentage === nextProps.widthPercentage;
};

NeumorphicDivider.propTypes = {
  widthPercentage: PropTypes.number
};

NeumorphicDivider.defaultProps = {
  widthPercentage: 100
};

NeumorphicDivider.displayName = 'NeumorphicDivider';

export default memo(NeumorphicDivider, arePropsEqual);